import JsonMap from '@/util/JsonMap';
import { IDeliveryOption } from '../session/models/IQtiSession';
import DeliveryOptionType from './DeliveryOptionTypeEnum';

class DeliveryOption {
  private _name: string;
  private _type: DeliveryOptionType = DeliveryOptionType.BASIC;
  private _settings: Map<string, string> = new Map<string, string>();
  private baseSettings: Map<string, string> = new Map<string, string>();

  constructor(name: string) {
    this._name = name;
  }

  set name(value: string) {
    this._name = value;
  }

  get name(): string {
    return this._name;
  }

  set type(type: DeliveryOptionType) {
    this._type = type;
  }

  get type(): DeliveryOptionType {
    return this._type;
  }

  addSetting(key: string, value: string): void {
    this._settings.set(key, value);
    if (!this.baseSettings.get(key)) {
      this.baseSettings.set(key, value);
    }
  }

  getChangedSettings(): Map<string, string> {
    return new Map([...this._settings].filter(([key, value]) => value != this.baseSettings.get(key)));
  }

  getSetting(key: string, defaultValue: string | undefined = undefined): string | undefined {
    const value: string | undefined = this._settings.get(key);
    return value ? value : defaultValue;
  }

  get settings(): Map<string, string> {
    return this._settings;
  }

  toDeliveryInterface(): IDeliveryOption {
    return { name: this._name, settings: new JsonMap(this.getChangedSettings()) };
  }
}

export default DeliveryOption;
